export default __webpack_public_path__ + "hangout.mp3";